/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {saveCreds} from '../api'

export const useMutationSaveCreds = createReactQueryMutationHook('saveCreds', saveCreds)
